'use es6';

import { createSelector } from 'reselect';
import { getHasBlogPostsScheduleScope } from './authSelectors';
import { getCurrentTabId } from 'ContentEditorUI/redux/selectors/routingSelectors';
import { SIDEBAR_PANELS } from 'ContentEditorUI/lib/sidebar/constants';
import { NAV_TABS_SHOW_SIDEBAR } from 'ContentEditorUI/constants/Sidebar';
import { basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
export const getBlogEditorTabs = basicSelectorWithStats(state => {
  return [{
    id: 'content',
    langKey: 'components.tabBar.content',
    showSidebar: NAV_TABS_SHOW_SIDEBAR['content']
  }, {
    id: 'settings',
    langKey: 'components.tabBar.settings',
    showSidebar: NAV_TABS_SHOW_SIDEBAR['settings']
  }, {
    id: 'optimize',
    langKey: 'components.tabBar.optimize',
    showSidebar: NAV_TABS_SHOW_SIDEBAR['optimize'],
    sidebarId: SIDEBAR_PANELS.optimizer
  }, {
    id: 'publishing',
    langKey: 'components.tabBar.publishingOptions',
    showSidebar: NAV_TABS_SHOW_SIDEBAR['publishing'],
    hidden: !getHasBlogPostsScheduleScope(state)
  }, {
    // Not an an actual tab in the tab bar, but preview does "act" like one (with its own route)
    id: 'preview',
    showSidebar: NAV_TABS_SHOW_SIDEBAR['preview'],
    hidden: true
  }, {
    id: 'revisions',
    showSidebar: NAV_TABS_SHOW_SIDEBAR['revisions'],
    hidden: true
  }];
});
export const getCurrentTab = createSelector([getCurrentTabId, getBlogEditorTabs], (currentTabId, blogSteps) => {
  const currentTab = blogSteps.find(tab => tab.id === currentTabId);
  if (currentTab) {
    return currentTab;
  }
  return blogSteps[1];
});